import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/shared/ui/button";

const VELTIZ_LOGO_URL = "https://storage.googleapis.com/veltiz-images/veltiz-logo-shadow2.svg";

export default function Header() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 flex items-center px-6 md:px-10 h-16 bg-background/80 backdrop-blur-md border-b border-border/50"
    >
      <Link to="/">
        <img
          src={VELTIZ_LOGO_URL}
          alt="Veltiz"
          className="h-3.5 md:h-[24px] w-auto"
        />
      </Link>

      <div className="ml-auto">
        <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground hover:bg-card" asChild>
          <a href={`https://${import.meta.env.VITE_CONSOLE_HOST ?? "test.console.veltiz.com"}/`}>
            Sign in
          </a>
        </Button>
      </div>
    </motion.header>
  );
}
